import { useEffect } from 'react';
import { getCurrentPlatform } from '../utils/platform-detection';

/**
 * Hook that applies platform-specific class names to the document body
 * This enables platform-specific CSS styling
 */
export const usePlatformClass = () => {
  useEffect(() => {
    const platform = getCurrentPlatform();
    const body = document.body;

    // Remove any existing platform classes
    body.classList.remove('ios-platform', 'android-platform', 'web-platform');

    // Add current platform class
    body.classList.add(`${platform}-platform`);

    // Cleanup on unmount
    return () => {
      body.classList.remove('ios-platform', 'android-platform', 'web-platform');
    };
  }, []);
};

export default usePlatformClass;